import React from 'react';
import moment from 'moment';
import { Table } from 'antd/lib';

const colums = [
  {
    title: 'Fecha del Deposito',
    dataIndex: 'fecha',
  },
  {
    title: 'Tipo',
    render: ({ tipo }) => (tipo ? tipo.toUpperCase() : 'DEPOSITO'),
  },
  {
    title: 'Fecha Inicio del Periodo',
    render: record => moment(record.fechaPeriodoInicio).format('DD/MM/YYYY'),
  },
  {
    title: 'Fecha Fin del Periodo',
    render: record => moment(record.fechaPeriodoFin).format('DD/MM/YYYY'),
  },
  {
    title: 'Banco o Sucursal',
    render: record =>
      record.tipo && record.tipo === 'transferencia'
        ? record.nombreBancoTransferencia
        : record.sucursal.nombre,
  },
  {
    title: 'Nro. Boleta Deposito',
    dataIndex: 'numBoletaDeposito',
  },
  {
    title: 'Total Depositado',
    dataIndex: 'importe',
    render: text =>
      text.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' }),
  },
];

class TablaMostrarDepositos extends React.Component {
  render() {
    return (
      <div>
        <Table
          bordered
          pagination={false}
          style={{ maxWidth: 1000, marginTop: 20 }}
          dataSource={this.props.data}
          columns={colums}
        />
      </div>
    );
  }
}

export default TablaMostrarDepositos;
